/**
 * Fórmula do boleto Vigor — extraída de views/Financeiro/FaturaCalculationModal.tsx
 * (era um cálculo inline num useEffect) para ficar testável por `node --test` e
 * reutilizável pelo guardrail de "fatura sem injeção" (ver faturaSemInjecao.ts).
 * Função pura, sem I/O.
 */

export interface EntradaCalculoBoleto {
  desconto_tarifa: number;
  desconto_bandeira: number;
  energia_injetada_gd1_kwh: number;
  energia_injetada_gd2_kwh: number;
  valor_tarifa_distribuidora: number;
  tarifa_bandeira: number;
  valor_parc_injet_s_desc: number;
  valor_restituicao_imposto: number;
  energia_nao_isenta: number;
  valor_juros_boleto: number;
  outros_multas_boleto: number;
  valor_parcelamentos_boleto: number;
}

export interface ResultadoCalculoBoleto {
  valor_consumo_scee_boleto: number;
  valor_adc_bandeira_boleto: number;
  valor_parc_injet_s_desc_boleto: number;
  valor_restituicao_imposto_boleto: number;
  valor_energia_nao_isenta_boleto: number;
  valor_juros_boleto: number;
  outros_multas_boleto: number;
  valor_parcelamentos_boleto: number;
  valor_boleto_vigor: number;
  total_com_vigor: number;
  economia: number;
  custo_s_vigor: number;
  consumo_total_gd_s_vigor: number;
  valor_adc_bandeira_s_vigor: number;
}

export function calcularValoresBoleto(f: EntradaCalculoBoleto): ResultadoCalculoBoleto {
  const {
    desconto_tarifa,
    desconto_bandeira,
    energia_injetada_gd1_kwh,
    energia_injetada_gd2_kwh,
    valor_tarifa_distribuidora,
    tarifa_bandeira,
    valor_parc_injet_s_desc,
    valor_restituicao_imposto,
    energia_nao_isenta,
    valor_juros_boleto,
    outros_multas_boleto,
    valor_parcelamentos_boleto,
  } = f;

  const valor_consumo_scee_boleto = (energia_injetada_gd1_kwh + energia_injetada_gd2_kwh) * (valor_tarifa_distribuidora * (1 - desconto_tarifa));
  const valor_adc_bandeira_boleto = (energia_injetada_gd1_kwh + energia_injetada_gd2_kwh) * (tarifa_bandeira * (1 - desconto_bandeira));
  const valor_parc_injet_s_desc_boleto = valor_parc_injet_s_desc * (-1);
  const valor_restituicao_imposto_boleto = valor_restituicao_imposto * (-1);
  const valor_energia_nao_isenta_boleto = energia_nao_isenta * (-1);

  const valor_boleto_vigor = valor_consumo_scee_boleto + valor_adc_bandeira_boleto + valor_parc_injet_s_desc_boleto + valor_restituicao_imposto_boleto + valor_energia_nao_isenta_boleto + valor_juros_boleto + outros_multas_boleto + valor_parcelamentos_boleto;

  const total_com_vigor = valor_boleto_vigor - valor_juros_boleto - outros_multas_boleto - valor_parcelamentos_boleto;

  const consumo_total_gd_s_vigor = (energia_injetada_gd1_kwh + energia_injetada_gd2_kwh) * valor_tarifa_distribuidora;
  const valor_adc_bandeira_s_vigor = (energia_injetada_gd1_kwh + energia_injetada_gd2_kwh) * tarifa_bandeira;
  const custo_s_vigor = consumo_total_gd_s_vigor + valor_adc_bandeira_s_vigor;
  const economia = custo_s_vigor - total_com_vigor;

  return {
    valor_consumo_scee_boleto,
    valor_adc_bandeira_boleto,
    valor_parc_injet_s_desc_boleto,
    valor_restituicao_imposto_boleto,
    valor_energia_nao_isenta_boleto,
    valor_juros_boleto,
    outros_multas_boleto,
    valor_parcelamentos_boleto,
    valor_boleto_vigor,
    total_com_vigor,
    economia,
    custo_s_vigor,
    consumo_total_gd_s_vigor,
    valor_adc_bandeira_s_vigor,
  };
}
